import React from 'react';
import { Section, SectionTitle } from '../Section';
import { CTAButton } from '../CTAButton';
import { Accordion } from '../Accordion';
import { faqs } from '../../data/landing';
export function FaqSection() {
  return <Section tone="ink" data-id="element-34" data-mp="1z3odwk7du8yz">
      <SectionTitle data-id="element-35" data-mp="1z2vek4ar6lqv">Preguntas</SectionTitle>
      <div className="mt-8" data-id="element-36" data-mp="1u64xper4jm4e">
        <Accordion idPrefix="faq" items={faqs.map(f => ({
        title: f.q,
        body: f.a
      }))} data-id="element-37" data-mp="1u4ttxexoieda" />
      </div>
    </Section>;
}
export function FinalSection() {
  return <Section tone="wine" className="text-center" data-id="element-38" data-mp="1l56qknle2yhl">
      <h2 className="font-serif text-[2.75rem] font-medium leading-[1.05] text-ivory md:text-[4rem]" data-id="element-39" data-mp="1l3dlvduc6oc8">
        Que tus manos <em className="italic text-gold" data-id="element-40" data-mp="1g7y9kqbz90hx">no se olviden.</em>
      </h2>
      <p className="mx-auto mt-6 max-w-[480px] text-[17px] leading-relaxed text-ivory/90 md:text-lg" data-id="element-41" data-mp="1b82c79xsc7bc">
        Clase completa, guía y reto de 7 días. $10.
      </p>
      <div className="mt-8" data-id="element-42" data-mp="35ka4sgmmwc3y">
        <CTAButton data-id="element-43" data-mp="35m3d00cwb4e2" />
      </div>
      <p className="mt-4 text-sm text-ivory/70" data-id="element-44" data-mp="35ip6qh142b1c">Garantía de 7 días · Pago seguro por Hotmart</p>
    </Section>;
}
export function Footer() {
  return <footer className="border-t border-gold/20 bg-ink px-6 pb-32 pt-10 text-center md:pb-12" data-id="element-45" data-mp="1m30vf45ck2qa">
      <div className="mx-auto max-w-[720px] space-y-3 text-sm leading-relaxed text-ivory/60" data-id="element-46" data-mp="182zx9wggv9ei">
        <p data-id="element-47" data-mp="1d0hvoswuy689">Contenido educativo para mayores de 18 años. No sustituye la atención médica ni sexológica.</p>
        <p data-id="element-48" data-mp="20rx14ujxl3nq">© 2026 Beatriz Espina · Términos · Privacidad</p>
      </div>
    </footer>;
}